import { InjectionToken } from '@angular/core';

export const PAGE_TITLE_SEPARATOR = new InjectionToken<string>('Page title separator');
